import { useRef, useState, useEffect } from "react";

export default function GridRow({ items, renderCard, onCountChange }) {
  const gridRef = useRef(null);
  const [cardsPerRow, setCardsPerRow] = useState(1);

  useEffect(() => {
    const update = () => {
      if (!gridRef.current) return;

      const style = window.getComputedStyle(gridRef.current);
      const columns = style.gridTemplateColumns.split(" ").length;

      setCardsPerRow((prev) => {
        if (prev !== columns) {
          onCountChange?.(columns);
          return columns;
        }
        return prev;
      });
    };

    update();

    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []); // <-- only once

  return (
    <div className="designs-grid1" ref={gridRef}>
      {items.slice(0, cardsPerRow).map(renderCard)}
    </div>
  );
}
